import { Component, Input, OnChanges } from "@angular/core";
import { OfferCalculator } from "../../../services/offer-calculator";
import { ProductCode } from "../../../../product/product.model";
import { getProductHeading } from "../../../models/large-loan-program.model";

@Component({
    selector: "ifc-offer-draw-slider",
    templateUrl: "./offer-draw-slider.component.html",
    styleUrls: ["./offer-draw-slider.component.scss"],
    standalone: false
})
export class OfferDrawSliderComponent implements OnChanges {
  @Input() offerCalculator: OfferCalculator;
  @Input() productCode: ProductCode;
  // True when the application also has large loan program offers, so a regular LOC reads "Standard".
  @Input() largeLoanProgramOffered: boolean;

  isLargeLoanProgram: boolean;
  icon: string;
  productLabel: string;
  title: string;

  get theme(): string {
    switch (this.productCode) {
      case ProductCode.LOC:
        return "blue";
      case ProductCode.Law:
        return "gray";
    }
  }
  // Mirrors the offer summary cards: same icons, and a small "Line of Credit" label over
  // "Standard" / the large loan program name when both kinds of line are on offer.
  ngOnChanges(): void {
    const heading = getProductHeading(
      this.offerCalculator?.applicationOfferBundle,
      this.offerCalculator?.productName,
      this.largeLoanProgramOffered
    );

    this.isLargeLoanProgram = heading.isLargeLoanProgram;
    this.productLabel = heading.label;
    this.title = heading.title;
    this.icon = this.getIcon();
  }

  onSampleDrawDisplay(value: number): string {
    // parseFloat drops trailing zeros: 1,000,000 → "1M", 1,250,000 → "1.25M".
    if (value >= 1000000)
      return parseFloat((value / 1000000).toFixed(2)).toString() + "M";

    return Math.round(value / 1000).toString() + "K";
  }

  onSampleDurationDisplay(value: number): string {
    return (value + 1).toString();
  }

  private getIcon(): string {
    if (this.isLargeLoanProgram) return "workspace_premium";

    switch (this.productCode) {
      case ProductCode.LOC:
        return "data_saver_off";
      case ProductCode.Law:
        return "work";
    }
  }

  get sampleDurationLength(): number {
    return this.offerCalculator.cards.length - 1;
  }
}
